import React from 'react';
import {links} from '../index';
export const ContactRibbon = (props) => {
	return (
		<div className='contact-ribbon'>
			<button
				className='contact-ribbon-btn btn-ripple'
				aria-expanded={props.isRibbon ? 'true' : 'false'}
				aria-pressed={props.isRibbon ? 'true' : 'false'}
				aria-controls='contact-ribbon-items'
                onClick={props.toggleRibbon}
            >
				<div className='ripple'></div>
				<i className='far fa-paper-plane' aria-hidden='true'></i>
			</button>
			<div
				className='contact-ribbon-bkg'
				style={{
					width: props.isRibbon ? '315px' : '0',
					backgroundColor: props.isRibbon ? '' : 'transparent',
				}}
            >
				<ul
					id='contact-ribbon-items'
					style={{
						visibility: props.isRibbon ? 'visible' : 'hidden',
						opacity: props.isRibbon ? '1' : '0',
					}}
					className='contact-ribbon-items'
                >
					<li>
						<a
							className='contact-ribbon-link'
							href={`mailto:${links.email}`}
                            tabIndex={props.isRibbon ? '0' : '-1'}
                            title='Email'
                        >
							<i className='far fa-envelope' aria-label='Email'></i>
						</a>
					</li>
					<li>
						<a
							className='contact-ribbon-link'
							href={links.gitlab}
							target='_blank'
							rel='noopener noreferrer'
                            tabIndex={props.isRibbon ? '0' : '-1'}
                            title='Gitlab'
                        >
							<i className='fab fa-gitlab' aria-label='Gitlab'></i>
						</a>
					</li>
					<li>
						<a
							className='contact-ribbon-link'
							href={links.linkedin}
							target='_blank'
							rel='noopener noreferrer'
                            tabIndex={props.isRibbon ? '0' : '-1'}
                            title='LinkedIn'
                        >
							<i className='fab fa-linkedin-in' aria-label='LinkedIn'></i>
						</a>
					</li>
					<li>
						<a
							className='contact-ribbon-link'
							href={links.codepen}
							target='_blank'
							rel='noopener noreferrer'
                            tabIndex={props.isRibbon ? '0' : '-1'}
                            title='Codepen'
                        >
							<i className='fab fa-codepen' aria-label='Codepen'></i>
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
};
